<script>

    import { toast } from 'bulma-toast'
    import { errorsStore, modalStore } from '../stores'

    import ErrorsService from '../$services/errors.service'
    import DateMethod from '../$methods/date.method'

    import Pagination from '../$components/pagination.svelte'
    import Search from '../$components/input.search.svelte'
    import Table from '../$components/table.svelte'
    import Button from '../$components/button.svelte'

    let query = {
        page: 0,
        find: null,
        provider: null,
        service: null
    }
    let metadata = {}
    let loading = false

    getErrors()

    async function getErrors() {

        loading = true
        const resp = await ErrorsService.getErrors(query)
        loading = false

        if(!resp.success)
            return toast({message: resp.error.message, type: 'is-danger'})

        errorsStore.set(resp.data.errors)
        metadata = resp.data.metadata
    }

</script>

<Table items={ $errorsStore.length } total={ metadata.total } { loading }>
    <div slot="toolbar">
        <div class="columns is-multiline is-align-items-flex-end mb-0">
            <div class="column">
                <Search bind:value={ query.find } on:enter={ getErrors } />
            </div>
        </div>
    </div>
    <div slot="footer">
        <Pagination bind:metadata bind:page={ query.page } on:change={ getErrors } />
    </div>
    <thead>
        <tr>
            <th>#</th>
            <th>Código soporte</th>
            <th>Usuario</th>
            <th>Proveedor</th>
            <th>Partner</th>
            <th>Servicio</th>
            <th>Mensaje</th>
            <th>Fecha</th>
            <th class="has-text-right">Acciones</th>
        </tr>
    </thead>
    <tbody>
        {#each $errorsStore as error, index}
            <tr>
                <td>{( metadata.items * query.page ) + ( index + 1 )}</td>
                <td>{ error.supportCode }</td>
                <td>
                    <div>{ error.user?.name }</div>
                    <div>{ error.user?.email }</div>
                </td>
                <td>{ error.provider }</td>
                <td>{ error.partner || error.provider }</td>
                <td>{ error.service }</td>
                <td class="is-size-7">{ error.message }</td>
                <td>{ DateMethod.dateTimeLarge(error.created) }</td>
                <td class="has-text-right">
                    <Button on:click={() => modalStore.open('error', 'modal', error)} icon="ellipsis-v" />
                </td>
            </tr>
        {/each}
    </tbody>
</Table>
